export const isSSR = import.meta.env.SSR;
